

















































































































import UserRequired from "../UserRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "@/components/companypage/Api";
import CompanySelector from "@/components/companyselector/CompanySelector.vue";
import {ApiMessage, Company, CompanyAccount, IdCard} from "@/modules/models";
import BaseApi from "@/store/modules/base";
import rd from "../../modules/vRoutedefs";
import ContactLink from "@/components/shared/ContactLink.vue";
import InfoBtn from "@/components/shared/InfoBtn.vue";
import InfoDialog from "@/components/InfoDialog.vue";
import {emailValidator} from "@/modules/utils";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-company-selector": CompanySelector,
        "at-contact-link": ContactLink,
        "at-info-btn": InfoBtn,
        "at-info-dialog": InfoDialog,
    }
})
export default class AccountInit extends UserRequired {
    @Inject()
    api!: Api;
    @Inject()
    baseApi!: BaseApi;

    @Prop({default: null})
    initOrgnum!: number | null;

    get rd() {
        return rd;
    }

    @Watch("initOrgnum", {immediate: true})
    async onInitOrgnumChanged() {
        if(this.initOrgnum != null) { // Company to init on is specified
            // Try loading company account (returns it if initBy is the same user, otherwise returns nothing, to not leak info others might have registered)
            // If existing incomplete companyAccount is returned, fill inn component state from it so that correct step is resolved.
            // If no companyAccount exists, try getting company orgnum from brreg. Component will then be initialized at step 1.
            this.account = await this.api.getCompanyAccount(this.initOrgnum);
            if(this.account === null) {
                this.pRegCompany = await this.api.getBrregCompany(this.initOrgnum);
            } else {
                this.pRegCompany = this.account.company;
            }

        // Resolve the most likely company user would want to create account on (the one he is employed by)
        } else if(!this.user.isVerified()) {
            this.pRegCompany = this.user.employedAt;

        } else {
            const latestCard = this.user.cards.find((card: IdCard, i: number, all: IdCard[]) => all.every((card2) => card.firstReg.millis() >= card2.firstReg.millis()) );
            if(latestCard) {
                this.pRegCompany = latestCard.company;
            }
        }
    }

    pRegCompany: Company | null = null;

    get regCompany() {
        return this.pRegCompany;
    }
    set regCompany(v: Company | null) {
        let ion: string = "";
        if(v) {
            ion = `${v.orgNum}`;
        }
        ignoreRedundantNavErr(this.$router.push({name: rd.company.init.name, query: {"init-orgnum": ion}}));
    }

    account: CompanyAccount | null = null;

    working = false;
    blockedMsg: ApiMessage | null = null; // Set if account init is blocked for some reason.

    // Resolve what step of the process component state is in
    get step() {
        return this.account && this.account.initStep || 1;
    }
    set step(v: number) {
        // Do nothing, step is resolved from other component state
        console.debug("ignoring set step", v);
    }

    get isAdminForInitCompany() {
        return this.account != null && this.baseApi.user != null && this.baseApi.user.isCompanyAdmin(this.account.company.orgNum);
    }

    async accountInit() {
        if(this.account == null) {
            if (this.regCompany != null) {
                // Normal route, init account on chosen company
                try {
                    this.working = true;
                    this.account = await this.api.getCompanyAccount(this.regCompany.orgNum);
                    if(this.account == null) {
                        this.blockedMsg = await this.api.checkCompanyInitBlocked(this.regCompany.orgNum);
                        if (this.blockedMsg === null) {
                            const initBy = this.baseApi.user && this.baseApi.user.person.guid || null;
                            if (initBy != null) {
                                this.account = CompanyAccount.init(this.regCompany, initBy);
                                // Save (incomplete) initalized account object on server
                                this.account.initStep = 2;
                                await this.api.saveCompanyAccount(this.account);
                            }
                        }
                    }
                } finally {
                    this.working = false;
                }
            } else {
                this.emitSnack(`Firma må velges før du kan gå videre`, "error");
            }
        } else {
            this.account.initStep = 2;
            this.api.saveCompanyAccount(this.account);
        }
    }

    showConfirmInfo = false;

    async confirmOrderInfo() {
        if(this.account != null) {
            if(this.account.invoiceEmail != null && this.account.invoiceEmail.length > 4) {
                if (this.account.orderRightConfirmed) {
                    this.orderRightConfirmMissing = false;
                    try {
                        this.working = true;
                        this.account.initStep = 3;
                        await this.api.saveCompanyAccount(this.account);
                    } finally {
                        this.working = false;
                    }
                } else {
                    this.orderRightConfirmMissing = true;
                    this.emitSnack(`Bestillingsrett må bekreftes før du kan gå videre`, "error");
                }
            } else {
                this.emitSnack(`E-post adresse for fakturering må fylles ut`, "error");
                this.emailInput().focus();
            }
        } else {
            throw new Error("account was null");
        }
    }

    emailInput(): HTMLInputElement {
        return this.$refs["email"] as HTMLInputElement;
    }

    async confirmTerms() {
        if(this.account != null) {
            if(this.account.systemTermsConfirmed) {
                try {
                    this.working = true;
                    this.account.initStep = 4;
                    await this.api.saveCompanyAccount(this.account);
                    // user should now be admin on account company, reload base state to reflect this.
                    const uA = this.baseApi.loadUser();
                    const cA = this.baseApi.loadCompany(this.account.company.orgNum);
                    await uA;
                    await cA;

                } finally {
                    this.working = false;
                }
            } else {
                this.systemTermsConfirmMissing = true;
                this.emitSnack(`Brukervilkår må godtas før du kan fortsette`, "error");
            }
        } else {
            throw new Error("account was null");
        }
    }

    back() {
        if(this.account != null && this.account.initStep > 1) {
            this.account.initStep--;
        }
    }

    get startPageTo() {
        return {name: rd.start.name};
    }

    get afterWizardTo() {
        return this.step === 4 && this.isAdminForInitCompany ? {name: rd.locations.setup.name} : this.startPageTo;
    }
    get afterWizardText() {
        return this.step === 4 && this.isAdminForInitCompany ? `Opprett anlegg` : `Startside`;
    }

    emailMissing = false;
    validateEmail() {
        return this.account != null && this.account.invoiceEmail != null && emailValidator(this.account.invoiceEmail) ? true : `Ugyldig e-post adresse`;
    }
    validateComment() {
        if(this.account && this.account.comment && this.account.comment.length > 1000) {
            return `Kommentar kan ikke være mer enn 1000 bokstaver/tegn.`
        }
        return true;
    }
    orderRightConfirmMissing = false;
    @Watch("account.orderRightConfirmed")
    onOrderRightConfirmedChange() {
        if(this.account && this.account.orderRightConfirmed) {
            this.orderRightConfirmMissing = false;
        }
    }

    systemTermsConfirmMissing = false;
    @Watch("account.systemTermsConfirmed")
    onSystemTermsConfirmedChange() {
        if(this.account && this.account.systemTermsConfirmed) {
            this.systemTermsConfirmMissing = false;
        }
    }

}
